import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

const secretManagerRouteRef = createRouteRef();

const secretManagerPage = PageBlueprint.make({
  params: {
    path: '/secret-manager',
    title: 'Secret Manager',
    icon: <VpnKeyIcon fontSize="inherit" />,
    noHeader: true,
    routeRef: secretManagerRouteRef,
    loader: async () => {
      const { SecretManagerPage } = await import('./SecretManagerPage');
      return <SecretManagerPage />;
    },
  },
});

export const secretManagerPlugin = createFrontendPlugin({
  pluginId: 'secret-manager',
  title: 'Secret Manager',
  icon: <VpnKeyIcon fontSize="inherit" />,
  routes: {
    root: secretManagerRouteRef,
  },
  extensions: [secretManagerPage],
});
